// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I9l56wnNFPvhYOj9P2YP {
  cursor: pointer;
}

.yBOMfE7roR0LZtHIgc_w {
  display: flex;
  grid-gap: 0.75rem;
  gap: 0.75rem;
}

.buINjFMrC28TfNDr2sga {
  display: none;
}

@media only screen and
  (max-width: 639px) {
  .yBOMfE7roR0LZtHIgc_w {
    grid-gap: 0.5rem;
    gap: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FooterBottomPartSocialIcons/FooterBottomPartSocialIcons.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAS;EAAT,YAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;;EACE;IACE,gBAAQ;IAAR,WAAQ;EACV;AACF","sourcesContent":[".icon {\n  cursor: pointer;\n}\n\n.footerBottomPartSocialIcons {\n  display: flex;\n  gap: 12px;\n}\n\n.hiddenLink {\n  display: none;\n}\n\n@media (--mobile) {\n  .footerBottomPartSocialIcons {\n    gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `I9l56wnNFPvhYOj9P2YP`,
	"footerBottomPartSocialIcons": `yBOMfE7roR0LZtHIgc_w`,
	"hiddenLink": `buINjFMrC28TfNDr2sga`
};
export default ___CSS_LOADER_EXPORT___;
